<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
//table封装组件
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import URL from '@/views/cms/util/url'
import UPDATE from '@/components/page/update.vue'
import Qs from 'qs'
import axios from 'axios'
import DateUtil from "@/utils/IM/tradeDataUtil";
let langOptionList={},typeOptionList = {},companyOptionList = {}
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  created() {
    this.intCompanyOptionList();
    this.initLangs()
    this.intTypes()
  },
  methods: {
    checkbox(row){
      this.deleteIds = row.map(key => key.id).join(",");
    },
    /*表格按钮点击事件*/
    bthClick (clickName, row) {
      if (clickName == "update"){
        row.companyCode=row.companyCode.split(",");
        this.$refs.childUpdate.open(row);
      }else if (clickName == "delete") {
        this.dataChanage(URL.keywords.del+"/"+row.id, {id: row.id}, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData);
            this.$message.success("suc");
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data){
      if("查询" == clickName){
        this.queryData = data;
        this.$refs.childTable.defaultQueryData(data);
      }else if("新增" == clickName){
        this.$refs.childUpdate.open();
      }
    },
    initLangs() {
      this.$axios.post(URL.lang.query, {}).then(res => {
        if (res.code == 0) {
          let data = res.result
          if (data && data.length > 0) {
            for (const i in data) {
              langOptionList[data[i].code] = data[i].displayName
            }
            this.updateData.cols.find(function(e) {
              return e.field == 'lang'
            }).data = data[0].code
          }
        }
      })
    },
    intTypes() {
      this.$axios.post(URL.product.typeList, {}).then(res => {
        if (res.code == 0) {
          let data = res.result
          if (data && data.length > 0) {
            for (const i in data) {
              typeOptionList[data[i].id] = data[i].name
            }
            this.formData.cols.find(function(e) {
              return e.field == 'typeId'
            }).optionList = typeOptionList
          }
          this.$refs.childTable.defaultQueryData( this.queryData);
        }
      })
    },
    intCompanyOptionList(){
      this.$axios.post(URL.company.query, {}).then(res => {
        if (res.code == 0) {
          let data = res.result.list
          if (data && data.length > 0) {
            for (const i in data) {
              companyOptionList[data[i].code] = data[i].name
            }
            this.updateData.cols.find(function(e) {
              return e.field == 'companyCode'
            }).data = data[0].code
          }
        }
      })
    },
    /*新增或跟提交数据触发事件*/
    submit(model){
      model.companyCode=model.companyCode.join(",");
      //根据是否包含id更新还是添加
      this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.keywords.edit:URL.keywords.edit,model,res => {
        if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("操作成功");
          this.$refs.childTable.defaultGetData(this.queryData);
        }else{

        }
      })
    },
    dataChanage(url,option,suc,fail){
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
        if(fail && (typeof fail == 'function')) fail(res);
      })
    }
  },
  data () {
    return {
      deleteIds:"",
      queryData:{},
      /*新增或更新*/
      updateData:{
        cols:[
          { title: 'id', field: 'id' ,hidden:true},
          { title: 'lang', field: 'lang', required:true ,type: 3, optionList: langOptionList },
          { title: 'typeId', field: 'typeId', required:true, type: 2, optionList: typeOptionList,isNumber:true },
          { title: 'companyCode', field: 'companyCode', required:true,type: 2 ,optionList: companyOptionList, multiple:true,data:[]},
          { title: 'keywords', field: 'keywords', textType: 'textarea', required:true},
        ]
      },
      /*from查询表单*/
      formData:{
        hasLable: true,
        cols:[
          { title: 'typeId', field: 'typeId',  type: 2, optionList: typeOptionList},
          { title: 'lang', field: 'lang', type: 2, optionList: langOptionList },
          { title: 'keywords', field: 'keywords' },
          { title: 'share', field: 'share',hidden:true, data:1},
          {click:"查询",auth:"cms:keywords:list"},
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: URL.keywords.query,  //请求路径和参数
        selection: true,
        sequence: true,
        cols: [
          { title: '主键', field: 'id'},
          { title: 'lang', field: 'lang'},
          { title: 'typeId', field: 'typeId',render:(data,full)=>{
              return typeOptionList[data];
            }},
          { title: 'keywords', field: 'keywords'},
          { title: 'companyCode', field: 'companyCode'},
        ]
      }
    }
  }
}
</script>
